import * as React from 'react';
import { compose, withHandlers, withState } from 'recompose';
import { Person } from '@components/person/_personTypes';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { formatDate } from '@utils/utils';

const enhance = compose(
  withState('itemClicked', 'setItemClicked', false),
  withState('loader', 'setLoader', false),
  withHandlers({
    handleClick: ({ checkedItems }) => () => {
      const nav = navigator as typeof navigator & {
        clipboard?: { writeText: (s: string) => Promise<void> };
      };

      if (nav && nav.clipboard && typeof nav.clipboard.writeText === 'function') {
        nav.clipboard.writeText(
          checkedItems
            .map(
              item =>
                `${item.person.fullName}${item.person.birthDate ? ', nar. ' + formatDate(item.person.birthDate) : ''}${
                  item.person.address.fullAddress ? ', bytem ' + item.person.address.fullAddress : ''
                }`
            )
            .join('\n')
        );
      }
    }
  })
);

const View: React.FC<{
  handleClick: () => void;
  checkedItems: Person[];
}> = ({ handleClick, checkedItems }) => (
  <Button label="Kopírovat do schránky" onClick={handleClick} disabled={checkedItems.length === 0} />
);
export const EventsParticipantCopyToClipboard: React.ComponentClass<Person> = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/events/EventsParticipantCopyToClipboard.tsx